<template>
	<div class="addcargo_default" ref="addcargo_default">
		<el-form ref="addcargoform" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
			<el-card class="box-card" shadow="hover">
				<div slot="header" class="clearfix"><span>商品信息</span></div>
				<addcargoinfo ref="addcargoinfo" l_mode="商品库"></addcargoinfo>
				<el-row>
					<el-col :span="24">
						<el-form ref="form" size="mini" label-width="80px">
							<el-form-item label="商品图片">
								<el-upload
									name="fileupload"
									class="upload-demo"
									:auto-upload="false"
									:action="uploadurl"
									:file-list="fileList"
									:on-change="UploadChange"
									:on-error="UploadError"
									:on-success="UploadSuccess"
									:show-file-list="false"
									:limit="1"
									accept="image/*"
									ref="upload"
								>
									<el-button size="mini" type="primary">上传图片</el-button>
								</el-upload>
								<div v-if="cargopic!=''">
									<el-card class="box-card" shadow="never" style="width:440px">
										<div slot="header" class="clearfix">
											<div class="headtitle" style="text-align: right;">
												<i class="el-icon-delete danger" title="删除" @click="delfile(0)"></i>
											</div>
										</div>
										<el-image :src="cargopic" style="width:400px"></el-image>
									</el-card>
								</div>
							</el-form-item>
						</el-form>
					</el-col>
				</el-row>
			</el-card>
		</el-form>
		<el-row class="footerhandler" v-if="!btndisabled">
			<el-col :span="5" style="color:transparent;">1</el-col>
			<el-col :span="4" class="submitBtn"><div @click="SaveBaseCargoInfo">保存</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="reback">返回</div></el-col>
		</el-row>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import addcargoinfo from '@/components/baseinfo/addcargoinfo.vue';
export default {
	components: {
		addcargoinfo
	},
	props: {},
	data() {
		return {
			btndisabled: false,
			windowHeight: window.innerHeight - 150,
			id: '',
			cargoinfo: {},
			divclass: 'addcargo_default',
			p_mode: 'cargo_1', //口岸名就是模板名
			t_id: 'cargo_1',
			iscopy: 0,
			uploadurl: '',
			fileList: [],
			successcount: 0,
			editid: '',
			cargopic:''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/baseinfo/addcargo.scss');
		});
		this.uploadurl = this.$apiprototype.ApiServer + '/Base/UploadCargoPic?domain=' + this.$apiprototype.WebServer + '&id=' + this.id;
	},
	methods: {
		init(param) {
			if (param.id != undefined) this.id = param.id;
			if (param.iscopy != undefined) this.iscopy = param.iscopy;
			this.GetCargoInfo();
		},
		GetPageLayout() {
			//debugger
			var that = this;
			//根据配置的导入模板
			this.$apipost.get.GetTransFormat({ p_mode: this.p_mode }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					if (res.set != undefined) {
						that.t_id = res.set.t_id;
						if (res.set.t_type == '商品')
							that.$refs.addcargoinfo.init({
								syscol: res.set.t_syscol,
								id: that.id,
								iscopy: that.iscopy,
								t_id: that.t_id,
								cargoinfo: that.cargoinfo
							});
					}
				}
			});
		},
		//排版
		GetCargoInfo() {
			var that = this;
			this.$tool.loading('正在加载', this.divclass);
			if (that.id != '') {
				this.$apipost.get.GetBaseCargoInfo({ id: that.id }).then(res => {
					if (res.info != undefined) {
						that.cargoinfo = res.info;
						if (res.info.cargopic != '') {
							that.fileList = [{ name: res.info.cargopic }];
							//加载图片
							that.showcargopic(res.info.cargopic);
						}
					}
					that.GetPageLayout();
				});
			} else {
				this.GetPageLayout();
			}
		},
		//获取商品信息实体
		getCargoObj() {
			var that = this;
			var cargoinfo = {};
			var info = '';
			var setlist = this.$refs.addcargoinfo._data.setlist;
			var error = '';
			if (setlist.length > 0) {
				setlist.forEach(e => {
					if (e.value == undefined) {
						e.value = '';
					}
					if (e.isnull == 'False' && e.value == '' && e.ishidden == 'False') {
						error = '请填写' + that.$refs.addcargoinfo.title + '-' + e.showname;
						info = '';
					} else {
						if (error == '') {
							if (e.coltype == 'float' && e.isnull == 'False' && e.ishidden == 'False') {
								if (!isNaN(Number(e.value))) {
									error = that.$refs.addcargoinfo.title + '-' + e.showname + '格式不正确';
									info = '';
								}
							}
						}
					}
					if (error == '') info += '"' + e.colname + '":"' + e.value + '",';
					else return false;
				});
				if (error == '') {
					if (info != '') {
						info = info.replace(/\n/g, '');
						info = '{' + info.substring(0, info.length - 1) + '}';
						cargoinfo.info = JSON.parse(info);
					}
				}
			}
			if (error != '') {
				this.$tool.message(error, 0);
				cargoinfo = '';
			}
			return cargoinfo;
		},
		//上传附件改变时
		UploadChange(file, fileList) {
			var that = this;
			if (fileList.length > 0) {
				var list = [];
				fileList.forEach(e => {
					const isLt20M = e.size / 1024 / 1024 < 20;
					if (!isLt20M) {
						this.$tool.message(e.name + '已超过20M,不允许上传', 0);
						this.$refs.upload.abort(e);
					} else {
						list = list.concat(e);
					}
				});
				that.fileList = list;
				that.getLocalImg(file);
			}
		},
		UploadError(err, file, fileList) {
			console.log('上传错误 error', err);
		},
		//上传成功
		UploadSuccess(res, file, fileList) {
			this.successcount = parseInt(this.successcount) + 1;
			if (this.successcount == this.fileList.length) {
				this.$tool.loadingclose();
				//全部上传完成
				if (res.state == '1') {
					this.$tool.message('保存成功', 1);
					this.reback();
				} else this.$tool.message(res.message, 0);
			}
		},
		//移除上传的文件
		delfile(index) {
			this.$refs.upload.abort(this.fileList[index]);
			this.fileList.splice(index, 1);
			this.cargopic='';
		},
		//保存商品信息
		SaveBaseCargoInfo() {
			var that = this;
			var cargoinfo = that.getCargoObj();
			if (cargoinfo.info != undefined) {
				cargoinfo.u_userid = localStorage.getItem('userid');
				cargoinfo.p_mode = this.p_mode;
				cargoinfo.t_id = this.t_id;
				cargoinfo.u_account = localStorage.getItem('u_account');
				cargoinfo.u_name = localStorage.getItem('u_name');
				cargoinfo.u_company = localStorage.getItem('u_company');
				cargoinfo.editid = this.id;
				this.editid = this.id;
				this.btndisabled = true;
				this.$tool.loading('正在保存', this.divclass);
				this.$apipost.post.SaveInfo({ paraminfo: cargoinfo }).then(res => {
					that.btndisabled = false;
					if (res.state == '1') {
						that.id = res.pkval;
						if (that.fileList.length > 0) {
							if (that.fileList[0].status == 'ready') {
								that.uploadurl = that.$apiprototype.ApiServer + '/Base/UploadCargoPic?domain=' + that.$apiprototype.WebServer + '&id=' + that.id;

								this.$nextTick(function() {
									that.$refs.upload.submit();
								});
							}
						} else {
							if (that.editid != '') {
								//清除商品图片
								this.$apipost.post.DelBaseCargoPic({id: that.editid }).then(delres => {
									//console.log('delres', delres);
								});
							}
							this.$tool.loadingclose();
							this.$tool.message('保存成功', 1);
							that.reback();
						}
					} else {
						this.$tool.loadingclose();
						this.$tool.message(res.message, 0);
						if(res.localfilename!=undefined)
							this.$tool.downfile(that,res.localfilename);
					}
				});
			}
		},
		//返回
		reback() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		getLocalImg(file) {
			// 获取上传图片的本地url，用于上传前的本地预览
			var that=this;
			 let reader = new FileReader()
			  reader.readAsDataURL(file.raw)
			  reader.onload = () => {
			    that.cargopic = reader.result;
			  }
		},
		showcargopic(filename){
			var that=this;
			this.$apipost.get.ShowFile({ filename: filename,syscode:'QG_SPK'}).then(res => {
				if (res.state=='1') {
					if(res.label_base!='')
						that.cargopic=res.label_base;
				}
			});
		}
	}
};
</script>

<style></style>
